import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { orgLibraryService } from "@/services/orgLibraryService";

export function useOrgLibrary() {
  return useQuery({ queryKey: ["org-library"], queryFn: orgLibraryService.library });
}

export function useCompliance(enabled = true) {
  return useQuery({ queryKey: ["org-compliance"], queryFn: orgLibraryService.compliance, enabled });
}

export function useTeams(enabled = true) {
  return useQuery({ queryKey: ["org-teams"], queryFn: orgLibraryService.teams, enabled });
}

function useInvalidating(fn, keys, options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    ...options,
    onSuccess: (...args) => {
      keys.forEach((k) => qc.invalidateQueries({ queryKey: k }));
      options.onSuccess?.(...args);
    },
  });
}

const LIB = ["org-library"];
const TEAMS = ["org-teams"];

export const useSetVisibility = (o) => useInvalidating(orgLibraryService.setVisibility, [LIB], o);
export const useSetCourseType = (o) => useInvalidating(orgLibraryService.setCourseType, [LIB, ["org-compliance"]], o);
export const useDeleteOrgCourse = (o) => useInvalidating(orgLibraryService.deleteCourse, [LIB], o);
export const useCreateTeam = (o) => useInvalidating(orgLibraryService.createTeam, [TEAMS, LIB], o);
export const useRenameTeam = (o) => useInvalidating(orgLibraryService.renameTeam, [TEAMS], o);
export const useDeleteTeam = (o) => useInvalidating(orgLibraryService.deleteTeam, [TEAMS, LIB], o);
export const useAddTeamMember = (o) => useInvalidating(orgLibraryService.addTeamMember, [TEAMS], o);
export const useRemoveTeamMember = (o) => useInvalidating(orgLibraryService.removeTeamMember, [TEAMS], o);
